// How the quota screens name people and teams (U7: no id shown). A person never reads an internal
// id: when the wire carries no name, the screen says so in these words instead of printing it.
// The same rule as the AllCode admin's `screens/names.ts`; TASK-580 retires that copy.

// A person's name is the library's one helper (primitives/person-name, IA-1: never the external id).
export { personName, UNKNOWN_USER, type PersonNameParts } from "../../primitives/person-name";
export const UNKNOWN_TEAM = "Unknown team";

/** The team's name, else "Unknown team". */
export function teamName(name: string | null | undefined): string {
  return name?.trim() || UNKNOWN_TEAM;
}
